export function includesKey<FullKeys extends string, PartKeys extends FullKeys>(
  partKeys: PartKeys[],
  key: FullKeys
): key is PartKeys {
  return (partKeys as FullKeys[]).includes(key);
}
